import request from '@/utils/request'

let Out_managementApi = {

  /*出库列表*/
  list(data) {
    return request._post('/shop/plus.out_management.Index/index', data);
},
/*添加出库*/
add(data) {
    return request._post('/shop/plus.out_management.Index/add', data);
},
/*修改出库*/
edit(data) {
    return request._post('/shop/plus.out_management.Index/edit', data);
},
/*删除出库*/
del(data) {
    return request._post('/shop/plus.out_management.Index/del', data);
},
/*出库详情*/
detail(data) {
  return request._post('/shop/plus.out_management.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.out_management.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.out_management.Setting/getSetting', data, errorback);
    },
}
export default Out_managementApi;



// WEBPACK FOOTER //
// ./src/api/out_management.js